import React from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { FormatedDate } from 'Utils/functions'

export const ModifiedBySection = () => {
  const param = useParams()
  const { sellOrderPostData } = useSelector(state => state.sellOrder)

  const documentDate =
    sellOrderPostData?.Data?.SalesDocumentInfo?.LastModifiedDate
  const salesAgent =
    sellOrderPostData?.Data?.SalesDocumentInfo?.LastModifiedByName
  const isCreated = param?.isPreorderValidatedOnRoute === 'created'

  const showContent = isCreated && documentDate

  if (!showContent) return null

  return (
    <div
      style={{ display: 'flex', marginTop: '16px' }}
      data-testid="container-modified-by">
      <p style={{ fontSize: '12px' }} data-testid="label-modified-info">
        Fecha de última modificación: {FormatedDate(documentDate)}
        {'  |  '}
        Modificado por: {salesAgent || 'Desconocido'}
      </p>
    </div>
  )
}
